<template>
    <div>
        <CoreTwoColumnsRow>
            <template #left>
                <CoreBorderWrapper
                    class="flex-grow-1 flex-shrink-1 flex-basis-55"
                    :condensed="true"
                >
                    {{ $t('§contracts.customer_uid') }}
                    {{ isFieldRequired('customer_uid') }}
                </CoreBorderWrapper>
            </template>

            <template #right>
                <CoreStringInput
                    class="flex-grow-1 flex-shrink-1 flex-basis-45"
                    placeholder="§ui.placeholder_input_customer_uid"
                    name="customer_uid"
                    :condensed="true"
                    :disabled="contractStore.saving_customer_uid"
                    :validator="v$.customer_uid"
                    v-model="inputs.customer_uid"
                />
            </template>
        </CoreTwoColumnsRow>

        <div class="flex justify-start mt-3 gap-2">
            <CoreButton
                icon="pi-save"
                label="§ui_button.save"
                name="saveCustomerUid"
                :disabled="!isValid || contractStore.saving_customer_uid"
                :loading="contractStore.saving_customer_uid"
                @click="handleSave"
            />

            <CoreButton
                label="§ui_button.cancel"
                name="closeModal"
                variant="tertiary"
                :disabled="contractStore.saving_customer_uid"
                @click="modalStore.setClose"
                icon="pi-times"
            />
        </div>
    </div>
</template>

<script>
import { useVuelidate } from '@vuelidate/core'
import { required, minLength, maxLength } from '@vuelidate/validators'
import { useContractStore } from '@/stores/contract'
import { useModalStore } from '@/stores/modal'
import CoreTwoColumnsRow from '@/components/core/CoreTwoColumnsRow.vue'
import CoreBorderWrapper from '@/components/core/CoreBorderWrapper.vue'
import CoreStringInput from '@/components/core/CoreStringInput.vue'
import CoreButton from '@/components/core/CoreButton.vue'

export default {
    name: 'CustomerUidModal',

    components: {
        CoreTwoColumnsRow,
        CoreBorderWrapper,
        CoreStringInput,
        CoreButton,
    },

    data() {
        return {
            inputs: {
                customer_uid: '',
            },
            v$: {},
        }
    },

    computed: {
        isValid() {
            return !this.v$.$invalid
        },

        rules() {
            return {
                customer_uid: {
                    required,
                    minLength: minLength(1),
                    maxLength: maxLength(64),
                },
            }
        },
    },

    created() {
        this.contractStore = useContractStore()
        this.modalStore = useModalStore()
        this.inputs.customer_uid = this.contractStore.contractData.customer_uid
    },

    mounted() {
        this.v$ = useVuelidate(this.rules, this.inputs)
    },

    methods: {
        async handleSave() {
            if (!this.contractStore.saving_customer_uid) {
                await this.contractStore.updateCustomerUid(this.inputs.customer_uid)
                this.modalStore.setClose()
            }
        },

        handleClose() {
            this.$store.commit('modal/SET_CLOSE')
        },
    },
}
</script>
